/* Farah Store – Darin design interactions */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var EN = (document.documentElement.lang || '').indexOf('en') === 0;
  var L = function (ar, en) { return EN ? en : ar; };

  /* ---- Mobile menu drawer ---- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-fr-menu-open]');
    var close = e.target.closest('[data-fr-menu-close]');
    var d = $('[data-fr-menu]');
    if (!d) return;
    if (open) { d.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    if (close) { d.hidden = true; document.documentElement.style.overflow = ''; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var d = $('[data-fr-menu]'); if (d && !d.hidden) { d.hidden = true; document.documentElement.style.overflow = ''; } closeSheet(); }
  });

  /* ---- Slider dots for mobile tracks ---- */
  function initDots(root) {
    $$('[data-fr-track]', root).forEach(function (track) {
      var dots = track.parentElement.querySelector(':scope > [data-fr-dots]');
      if (!dots || track.dataset.frReady) return;
      track.dataset.frReady = '1';
      function build() {
        dots.innerHTML = '';
        if (getComputedStyle(track).gridAutoFlow.indexOf('column') === -1) return;
        var pages = Math.ceil(track.scrollWidth / Math.max(track.clientWidth, 1) - 0.05);
        if (pages < 2) return;
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', String(i + 1));
          (function (i) { b.addEventListener('click', function () { var dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1; track.scrollTo({ left: dir * i * track.clientWidth, behavior: 'smooth' }); }); })(i);
          dots.appendChild(b);
        }
        update();
      }
      function update() {
        var bs = dots.children; if (!bs.length) return;
        var idx = Math.round(Math.abs(track.scrollLeft) / Math.max(track.clientWidth, 1));
        for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('is-active', i === Math.min(idx, bs.length - 1));
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', build);
      build();
    });
  }

  /* ---- Tabs ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fr-tab]'); if (!t) return;
    var sec = t.closest('.fr-prods'); var i = t.dataset.frTab;
    $$('[data-fr-tab]', sec).forEach(function (b) { var on = b === t; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
    $$('[data-fr-panel]', sec).forEach(function (p) { p.hidden = p.dataset.frPanel !== i; });
    initDots(sec);
  });

  /* ---- Swatches swap the card image ---- */
  function swap(sw) {
    var card = sw.closest('.fr-card'); if (!card || !sw.dataset.img) return;
    var img = card.querySelector('.fr-card__img:not(.fr-card__img--alt)'); if (!img) return;
    img.srcset = sw.dataset.srcset || ''; img.src = sw.dataset.img;
    $$('.fr-sw', card).forEach(function (s) { s.classList.toggle('is-active', s === sw); });
  }
  document.addEventListener('mouseover', function (e) { var sw = e.target.closest && e.target.closest('.fr-sw--img'); if (sw) swap(sw); });
  document.addEventListener('click', function (e) { var sw = e.target.closest('.fr-sw--img'); if (sw) { e.preventDefault(); swap(sw); } });

  /* ---- Add to cart from cards ---- */
  function openCart() {
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    setTimeout(function () {
      try {
        var jq = window.jQuery_T4NT || window.jQuery;
        if (window.T4SThemeSP && T4SThemeSP.Drawer && jq) { T4SThemeSP.Drawer.opend(jq('#t4s-mini_cart')); return; }
      } catch (e) {}
      location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    }, 350);
  }
  function addToCart(id, btn, after) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = L('...جاري الإضافة', 'Adding...'); }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (btn) { btn.textContent = L('تمت الإضافة ✓', 'Added ✓'); }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); });
      })
      .then(function () { if (after) after(); openCart(); })
      .catch(function (err) { if (btn) btn.textContent = (err && err.description) || L('حصلت مشكلة، جربي تاني', 'Something went wrong, try again'); throw err; })
      .finally(function () { if (btn) setTimeout(function () { btn.disabled = false; btn.textContent = btn.dataset.label; }, 1600); });
  }

  /* variant picker sheet */
  var sheet;
  function closeSheet() { if (sheet) { sheet.hidden = true; } }
  function openSheet(data) {
    if (!sheet) {
      sheet = document.createElement('div'); sheet.className = 'fr-sheet'; sheet.hidden = true;
      sheet.innerHTML = '<div class="fr-sheet__overlay" data-fr-sheet-close></div><div class="fr-sheet__panel" role="dialog" aria-modal="true"><button type="button" class="fr-icon-btn fr-sheet__close" data-fr-sheet-close aria-label="' + L('إغلاق', 'Close') + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button><div class="fr-sheet__head"><img alt=""><div><p class="fr-sheet__name"></p><span class="fr-sheet__price"></span></div></div><p class="fr-sheet__label">' + L('اختاري', 'Choose') + '</p><div class="fr-sheet__opts"></div><p class="fr-sheet__msg"></p><button type="button" class="fr-btn fr-btn--gold fr-sheet__add">' + L('أضف إلى السلة', 'Add to cart') + '</button></div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) { if (e.target.closest('[data-fr-sheet-close]')) closeSheet(); });
    }
    var img = sheet.querySelector('.fr-sheet__head img'); img.src = data.image || ''; img.style.display = data.image ? '' : 'none';
    sheet.querySelector('.fr-sheet__name').textContent = data.title;
    var price = sheet.querySelector('.fr-sheet__price');
    sheet.querySelector('.fr-sheet__label').textContent = L('اختاري ', 'Choose ') + (data.options || []).join(' / ');
    var box = sheet.querySelector('.fr-sheet__opts'); box.innerHTML = '';
    var msg = sheet.querySelector('.fr-sheet__msg'); msg.textContent = '';
    var chosen = null;
    data.variants.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'fr-sheet__opt'; b.textContent = v.title; b.disabled = !v.available;
      b.addEventListener('click', function () { chosen = v; price.textContent = v.price; msg.textContent = ''; $$('.fr-sheet__opt', box).forEach(function (x) { x.classList.toggle('is-active', x === b); }); });
      box.appendChild(b);
    });
    var firstAv = data.variants.filter(function (v) { return v.available; })[0];
    price.textContent = firstAv ? firstAv.price : '';
    var add = sheet.querySelector('.fr-sheet__add');
    add.onclick = function () {
      if (!chosen) { msg.textContent = L('من فضلك اختاري ', 'Please choose ') + ((data.options || [])[0] || L('المقاس', 'a size')); return; }
      addToCart(chosen.id, add, closeSheet).catch(function () {});
    };
    sheet.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-fr-add]');
    if (a) { e.preventDefault(); addToCart(a.dataset.frAdd, a).catch(function () {}); return; }
    var p = e.target.closest('[data-fr-pick]');
    if (p) {
      e.preventDefault();
      var j = p.parentElement.querySelector('[data-fr-variants]');
      try { openSheet(JSON.parse(j.textContent)); } catch (err) { location.href = p.closest('.fr-card').querySelector('a').href; }
    }
  });

  function init(root) { initDots(root); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
